const PAY_BUTTON_SELECTOR = '[data-payment-pay]';
const PAY_BUSY_ATTR = 'data-pay-busy';
const COMPLETED_ATTR = 'data-kiosk-payment-completed';
const KEY_GUARD_ATTR = 'data-pay-key-guard';

let chargeSucceededLock = false;

export function lockPayButtonsAfterCharge() {
    chargeSucceededLock = true;
    document.documentElement.setAttribute(COMPLETED_ATTR, '1');
    setPaymentPayButtonDisabled(true);
}

export function clearPayButtonsChargeLock() {
    chargeSucceededLock = false;
    document.documentElement.removeAttribute(COMPLETED_ATTR);
}

export function isPayButtonsChargeLocked() {
    return chargeSucceededLock === true;
}

export function setPaymentPayButtonDisabled(disabled) {
    if (chargeSucceededLock && disabled === false) {
        return;
    }
    document.querySelectorAll(PAY_BUTTON_SELECTOR).forEach((button) => {
        if (disabled) {
            button.setAttribute(PAY_BUSY_ATTR, '1');
            button.disabled = true;
            return;
        }
        button.removeAttribute(PAY_BUSY_ATTR);
        button.disabled = false;
    });
}

export function isPaymentPayButtonBusy() {
    const button = document.querySelector(PAY_BUTTON_SELECTOR);
    return Boolean(button?.hasAttribute(PAY_BUSY_ATTR));
}

export function bindPayButtonKeyboardGuard(button) {
    if (!button || button.hasAttribute(KEY_GUARD_ATTR)) {
        return;
    }
    button.setAttribute(KEY_GUARD_ATTR, '1');
    button.addEventListener('keydown', function (event) {
        const activatesButton = event.key === ' ' || event.key === 'Enter';
        if (!activatesButton) {
            return;
        }
        if (event.repeat || button.disabled || button.hasAttribute(PAY_BUSY_ATTR)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    });
}
